import Translate from 'translate.js'

// tslint:disable:no-any
const defaultLanguage = 'es'
const detectedLanguage = ((navigator.languages && navigator.languages[0]) || navigator.language || (navigator as any).userLanguage).toLowerCase()

export const lang = detectedLanguage.substr(0, 2)

export const langAndRegion = detectedLanguage

const languages = {
  es: {
    typePassenger: {
      adult: 'adulto',
      child: 'niño',
      handicapped: 'discapacitado',
      infant: 'bebe',
      military: 'militar',
      senior: 'mayor',
      student: 'estudiante'
    },
    add: 'añadir',
    address: 'dirección',
    administrator: 'administrador',
    adult: 'adulto',
    atraccion: 'atraccion',
    autobus: 'autobus',
    avion: 'avion',
    barco: 'barco',
    bicicleta: 'bicicleta',
    buceo: 'buceo',
    bus: 'bus',
    busParada: 'busParada',
    busTuristico: 'busTuristico',
    cancel: 'cancelar',
    canceled: 'cancelado',
    excursion: 'excursion',
    funcion: 'funcion',
    funicular: 'funicular',
    handicapped: 'discapacitado',
    helicopero: 'helicopero',
    hopOnOff: 'hopOnOff',
    idavuelta: 'idavuelta',
    infant: 'bebe',
    lancha: 'lancha',
    military: 'militar',
    moto: 'moto',
    motoAgua: 'motoAgua',
    museo: 'museo',
    panoramica: 'panoramica',
    parqueAtracciones: 'evento',
    patin: 'patin',
    ruta: 'ruta',
    senior: 'mayor',
    student: 'estudiante',
    trenParada: 'trenParada',
    ticket: 'ticket',
    tranvia: 'tranvia',
    trenecito: 'trenecito',
    all: 'todos',
    appName: 'Tpv web',
    article: 'artículo',
    articles: 'artículos',
    barcode: 'código de barras',
    branch: 'delegación',
    brand: 'marca',
    branches: 'delegaciones',
    businessName: 'nombre fiscal',
    businessunit: 'negocio',
    businessUnit: 'negocio',
    businessunits: 'negocios',
    businessUnits: 'negocios',
    calculadora_precios_sin_iva: 'calculadora de precios sin iva',
    cashDeskOpen: 'la caja ya está abierta',
    checkins: 'checkins',
    city: 'ciudad',
    client: 'cliente',
    code: 'código',
    codeDiscount: 'código descuento',
    confirmDelete: '¿Confirmar eliminar?',
    confirmDisable: '¿Confirmar deshabilitar?',
    confirmEnable: '¿Confirmar habilitar?',
    contactName: 'persona de contacto',
    contactPhone: 'teléfono de contacto',
    cost: 'coste',
    customers: 'clientes',
    date: 'fecha',
    datecheck: 'emitido',
    daterefund: 'cancelado',
    datevalited: 'validado',
    dateBook: 'fecha de book',
    dateClose: 'fecha cierre',
    dateOpen: 'fecha apertura',
    day: 'hoy',
    delete: 'eliminar',
    description: 'descripción',
    desde: 'desde',
    destination: 'destino',
    devices: 'dispositivos',
    disable: 'deshabilitar',
    disabled: 'deshabilitados',
    disabled_at: 'deshabilitado en',
    email: 'email',
    enable: 'habilitar',
    families: 'familias',
    family: 'familia',
    footer: 'pie',
    hasta: 'hasta',
    header: 'cabecera',
    help: 'ayuda',
    hoponHopoff: 'HopON-HopOFF',
    hora: 'hora',
    id: 'ID',
    image: 'imagen',
    imageProperties: 'imagen en formato jpg con un mínimo de 600x600 px',
    invoice: 'factura',
    lastname: 'apellidos',
    license: 'licencia',
    licenses: 'licencias',
    logIn: 'iniciar sesión',
    logOut: 'salir',
    manufacturer: 'fabricante',
    margin: 'margen',
    model: 'modelo',
    modelo: 'modelo',
    month: 'mes',
    name: 'nombre',
    none: 'ninguna',
    nothingModified: 'no se han realizado cambios',
    number: 'numero',
    numero: 'número de ticket',
    ok: 'aceptar',
    operationlines: 'líneas de operación',
    operationline: 'línea de operación',
    operationLine: 'línea de operación',
    origin: 'origen',
    orphan: 'sin familia',
    parael: 'para el',
    parent: 'padre',
    passengercategories: 'categorias de pasajero',
    password: 'contraseña',
    percentage: 'porcentaje',
    phone: 'teléfono',
    policy: 'política',
    price: 'precio',
    pricesWithoutTax: 'precios (sin IVA)',
    printPrice: 'imprimir precio',
    propierties: 'propiedades',
    province: 'provincia',
    quantity: 'cantidad',
    receiptLayout: 'Pantilla de recibo',
    recovery: 'olvidé la contraseña',
    refunded: 'abonado',
    reference: 'referencia',
    reports: 'informes',
    reset: 'reiniciar',
    role: 'rol',
    routes: 'rutas',
    saleDate: 'desde',
    sales: 'ventas',
    save: 'guardar',
    search: 'buscar',
    seller: 'vendedor',
    send: 'enviar',
    serial: 'numero de serie',
    settings: 'configuración',
    sinValidar: 'sin validar',
    stock: 'stock',
    stockable: 'almacenable',
    /*stretch: 'tramo',*/
    stretch: 'servicio',
    /*stretches: 'tramos',*/
    stretches: 'servicios',
    supervisor: 'supervisor',
    tax: 'impuesto',
    taxes: 'impuestos',
    terminal: 'terminal de venta',
    terminalnumero: 'número',
    tickets: 'tickets',
    ticketsRefunded: 'tickets cancelados',
    tramoHora: 'tramo hora',
    tramoHorario: 'horario',
    type: 'tipo',
    typePassengers: 'tipo de pasajero',
    timeAdvance: 'Tiempo anterior a hora booking para validar ticket (en minutos)',
    timeCancel: 'Tiempo máximo para cancelar ticket (en minutos)',
    timeExpirationDay: 'Días válidos para el ticket. 0 para el resto del día actual',
    timeExpirationHour: 'Minutos de validez para el ticket a partir de hora de booking',
    tin: 'NIF-CIF',
    totalDiscount: 'total descuento',
    totalRefund: 'total cancelado',
    tradename: 'nombre comercial',
    username: 'usuario',
    user: 'usuario',
    users: 'usuarios',
    validoPara: 'válido para',
    vuelta: 'ida-vuelta',
    week: 'semana',
    wharehouse: 'mi catálogo',
    year: 'año',
    zip: 'código postal',
    netAmount: 'base imponible',
    discount: 'descuento',
    taxBase: 'base impuestos',
    taxAmount: 'impuestos',
    total: 'total',
    from: 'desde',
    to: 'hasta',
    cashDesk: 'caja',
    state: 'estado',
    cashAmount: 'efectivo',
    cardAmount: 'tarjeta',
    open: 'apertura',
    close: 'cierre',
    partialClose: 'cierre parcial',
    error: {
      unableConnect: 'imposible conectar, comprobar conexión',
      tryAgainLater: 'intentar de nuevo más tarde',
      loginAgain: 'iniciar sesión de nuevo',
      userNoAccess: 'acceso prohibido para este tipo de usuario'
    }
  },
  en: {
    typePassenger: {
      adult: 'adult',
      child: 'child',
      handicapped: 'handicapped',
      infant: 'infant',
      military: 'military',
      senior: 'senior',
      student: 'student'
    },
    add: 'add',
    address: 'address',
    administrator: 'administrator',
    all: 'all',
    appName: 'Tpv web',
    articles: 'articles',
    atraccion: 'attraction',
    autobus: 'bus',
    avion: 'plane',
    barco: 'ship',
    barcode: 'barcode',
    bicicleta: 'bicycle',
    branch: 'branch',
    branches: 'branches',
    brand: 'brand',
    buceo: 'diving',
    bus: 'bus',
    businessName: 'business name',
    businessunit: 'business unit',
    businessUnit: 'business unit',
    businessunits: 'business units',
    businessUnits: 'business units',
    busParada: 'bus stop',
    busTuristico: 'touristic bus',
    calculadora_precios_sin_iva: 'price calculator without VAT',
    cancel: 'cancel',
    canceled: 'canceled',
    cardAmount: 'card amount',
    cashAmount: 'cash amount',
    cashDesk: 'cash desk',
    cashDeskOpen: 'cash desk already opened',
    checkins: 'checkins',
    child: 'child',
    city: 'city',
    client: 'client',
    close: 'close',
    code: 'code',
    codeDiscount: 'code discount',
    confirmDelete: 'confirm delete?',
    confirmEnable: 'confirm enable?',
    contactName: 'contact name',
    contactPhone: 'contact phone',
    cost: 'cost',
    customers: 'customers',
    dateBook: 'date book',
    datecheck: 'date check',
    dateClose: 'date close',
    dateOpen: 'date open',
    daterefund: 'date refund',
    datevalited: 'date valited',
    day: 'today',
    delete: 'delete',
    description: 'description',
    desde: 'from',
    destination: 'destination',
    devices: 'devices',
    disable: 'disable',
    disabled_at: 'disbled at',
    disabled: 'disabled',
    discount: 'discount',
    email: 'email',
    enable: 'enable',
    excursion: 'excursion',
    families: 'families',
    family: 'family',
    footer: 'footer',
    from: 'from',
    funcion: 'show',
    funicular: 'cableway',
    handicapped: 'handicapped',
    hasta: 'to',
    header: 'header',
    helicopero: 'helicopter',
    help: 'help',
    hoponHopoff: 'HopON-HopOFF',
    hopOnOff: 'hopOnOff',
    hora: 'hour',
    id: 'ID',
    idavuelta: 'round trip',
    image: 'image',
    infant: 'infant',
    invoice: 'invoice',
    lancha: 'boat',
    lastname: 'last name',
    license: 'license',
    licenses: 'licences',
    logIn: 'log in',
    loginAgain: 'log in again',
    logOut: 'log out',
    manufacturer: 'manufacturer',
    margin: 'margin',
    military: 'military',
    model: 'model',
    modelo: 'model',
    month: 'month',
    moto: 'motorcycle',
    motoAgua: 'jet ski',
    museo: 'museum',
    name: 'name',
    netAmount: 'net amount',
    none: 'none',
    nothingModified: 'nothing modified',
    number: 'number',
    numero: 'ticket number',
    ok: 'ok',
    open: 'open',
    operationline: 'operation line',
    operationlines: 'operation lines',
    origin: 'origin',
    orphan: 'without family',
    panoramica: 'panoramic',
    parael: 'for',
    parent: 'parent',
    partialClose: 'partial close',
    passengercategories: 'passenger categories',
    password: 'password',
    patin: 'skate',
    percentage: 'percentage',
    phone: 'phone',
    policy: 'policy',
    price: 'price',
    pricesWithoutTax: 'prices without tax',
    printPrice: 'print price',
    propierties: 'propierties',
    province: 'province',
    quantity: 'quantity',
    receiptLayout: 'receipt layout',
    recovery: 'i forgot the password',
    reference: 'reference',
    refunded: 'refunded',
    reports: 'reports',
    reset: 'reset',
    role: 'rol',
    routes: 'routes',
    ruta: 'route',
    saleDate: 'since',
    sales: 'sales',
    save: 'save',
    search: 'search',
    seller: 'seller',
    send: 'send',
    senior: 'senior',
    serial: 'serial number',
    settings: 'setting',
    sinValidar: 'not validated',
    state: 'state',
    stock: 'stock',
    stockable: 'stockable',
    stretch: 'stretch',
    stretches: 'stretches',
    student: 'student',
    supervisor: 'supervisor',
    tax: 'tax',
    taxAmount: 'tax amount',
    taxBase: 'tax base',
    taxes: 'taxes',
    terminal: 'sale terminal',
    terminalnumero: 'terminal number',
    ticketsRefunded: 'tickets refunded',
    timeAdvance: 'time before use time to validate the ticket (in minutes)',
    timeCancel: 'maximum time to cancel ticket (in minutes)',
    timeExpirationHour: 'minutes of validity of the ticket from the time of use',
    tin: 'Tin',
    to: 'to',
    total: 'total',
    totalDiscount: 'total discount',
    totalRefund: 'total refund',
    tradename: 'trade name',
    tramoHora: 'valid for a schedule',
    tramoHorario: 'schedule',
    tranvia: 'trolley car',
    trenecito: 'little train',
    type: 'type',
    typePassengers: 'type of passenger',
    user: 'user',
    username: 'user name',
    users: 'users',
    validoPara: 'valid for',
    vuelta: 'round trip',
    week: 'week',
    wharehouse: 'wharehouse',
    year: 'year',
    zip: 'postal code',
    parqueAtracciones: 'event',
    article: 'article',
    fecha: 'date',
    ticket: 'ticket',
    tickets: 'tickets',
    confirmDisable: 'confirm disable?',
    imageProperties: 'image in jpg format and with a minimun of 600x600 px',
    timeExpirationDay: 'valid days for the ticket. set "0" for the rest of the current day',
    trenParada: 'train stop',
    error: {
      unableConnect: 'unable to connect, check network',
      tryAgainLater: 'try again later',
      loginAgain: 'log in again',
      userNoAccess: 'prohibited access for this type of user'
    }
  },
  pt: {
    typePassenger: {
      adult: 'adulto',
      child: 'menino',
      handicapped: 'desabilitado',
      infant: 'bebê',
      military: 'militar',
      senior: 'major',
      student: 'aluno'
    },

    add: 'adicionar',
    address: 'endereço',
    administrator: 'administrador',
    adult: 'adulto',
    all: 'tudo',
    appName: 'Tpv web',
    articles: 'artigos',
    atraccion: 'atração',
    autobus: 'ônibus',
    avion: 'avião',
    barco: 'navio',
    barcode: 'código de barras',
    bicicleta: 'bicicleta',
    branch: 'delegação',
    branches: 'delagações',
    brand: 'marca',
    buceo: 'mergulho',
    bus: 'ônibus',
    businessName: 'nome fiscal',
    businessunit: 'negócio',
    businessUnit: 'negócio',
    businessunits: 'negócio',
    businessUnits: 'negócio',
    busParada: 'parada de ônibus',
    busTuristico: 'ônibus turístico',
    calculadora_precios_sin_iva: 'calculadora de preços sem IVA',
    cancel: 'cancelar',
    canceled: 'cancelado',
    cardAmount: 'cartão',
    cashAmount: 'dinheiro',
    cashDesk: 'caixa',
    cashDeskOpen: 'a caixa já está aberta',
    checkins: 'check-in',
    city: 'cidade',
    client: 'cliente',
    close: 'fechar',
    code: 'código',
    codeDiscount: 'código de desconto',
    confirmDelete: 'Confirmar exclusão?',
    confirmEnable: 'Confirmar ativação?',
    contactName: 'pessoa de contato',
    contactPhone: 'telefone de contato',
    cost: 'custo',
    customers: 'clientes',
    dateBook: 'data da reserva',
    datecheck: 'data de emissão',
    dateClose: 'data de fechamento',
    dateOpen: 'data de abertura',
    daterefund: 'cancelado',
    datevalited: 'validado',
    day: 'hoje',
    delete: 'remover',
    description: 'descrição',
    desde: 'de',
    destination: 'destino',
    devices: 'dispositivos',
    disable: 'desabilitar',
    disabled_at: 'desativado em',
    disabled: 'desabilitado',
    discount: 'desconto',
    email: 'email',
    enable: 'habilitar',
    excursion: 'excursão',
    families: 'famílias',
    family: 'familia',
    footer: 'pé',
    from: 'de',
    funcion: 'Função',
    funicular: 'teleférico',
    hasta: 'até',
    header: 'cabeçalho',
    helicopero: 'helicóptero',
    help: 'ajuda',
    hoponHopoff: 'HopON-HopOFF',
    hopOnOff: 'hopOnOff',
    hora: 'hora',
    id: 'ID',
    idavuelta: 'ida e volta',
    image: 'imagem',
    infant: 'bebê',
    invoice: 'fatura',
    lancha: 'barco',
    lastname: 'sobrenomes',
    license: 'licença',
    licenses: 'licenças',
    logIn: 'iniciar sessão',
    logOut: 'sair',
    manufacturer: 'fabricante',
    margin: 'margem',
    military: 'militar',
    model: 'modelo',
    modelo: 'modelo',
    month: 'mês',
    moto: 'motocicleta',
    motoAgua: 'moto aquática',
    museo: 'museu',
    name: 'nome',
    netAmount: 'tributável',
    none: 'nenhum',
    nothingModified: 'nenhuma alteração foi feita',
    number: 'numero',
    numero: 'número do bilhete',
    ok: 'aceitar',
    open: 'abertura',
    operationline: 'linha de operação',
    operationlines: 'linhas de operação',
    origin: 'origem',
    orphan: 'sem familia',
    panoramica: 'panorâmico',
    parael: 'para o',
    parent: 'pai',
    partialClose: 'fechamento parcial',
    passengercategories: 'categorias de passageiros',
    password: 'senha',
    patin: 'skate',
    percentage: 'porcentual',
    phone: 'telefone',
    policy: 'politica',
    price: 'preço',
    pricesWithoutTax: 'preços sem IVA',
    printPrice: 'imprima o preço',
    propierties: 'propriedades',
    province: 'província',
    quantity: 'quantidade',
    receiptLayout: 'modelo de recibo',
    recovery: 'Esqueci a senha',
    reference: 'referência',
    refunded: 'retornar',
    reports: 'relatórios',
    reset: 'reiniciar',
    role: 'função',
    routes: 'rotas',
    ruta: 'rota',
    saleDate: 'de',
    sales: 'vendas',
    save: 'salvar',
    search: 'procurar',
    seller: 'vendedor',
    send: 'enviar',
    senior: 'major',
    serial: 'número de série',
    settings: 'configuração',
    sinValidar: 'não validado',
    state: 'estado',
    stock: 'estoque',
    stockable: 'armazenável',
    stretch: 'serviço',
    stretches: 'serviços',
    student: 'aluno',
    supervisor: 'supervisor',
    tax: 'imposto',
    taxAmount: 'impostos',
    taxBase: 'base tributária',
    taxes: 'impostos',
    terminal: 'terminal de venda',
    terminalnumero: 'numero',
    ticketsRefunded: 'bilhetes cancelados',
    timeAdvance: 'Tempo antes do tempo de uso para validar o ticket (em minutos)',
    timeCancel: 'Tempo máximo para cancelar o ticket (em minutos)',
    timeExpirationHour: 'Minutos de validade do ticket a partir do momento do uso',
    tin: 'NIF-CIF',
    to: 'até',
    total: 'total',
    totalDiscount: 'desconto total',
    totalRefund: 'total cancelado',
    tradename: 'nome comercial',
    tramoHora: 'válido para o tempo',
    tramoHorario: 'horário',
    tranvia: 'bonde',
    trenecito: 'trenzinho',
    type: 'tipo',
    typePassengers: 'tipo de passageiro',
    user: 'usuário',
    username: 'usuário',
    users: 'usuários',
    validoPara: 'válido para',
    vuelta: 'ida e volta',
    week: 'semana',
    wharehouse: 'meu catálogo',
    year: 'ano',
    zip: 'código postal',
    parqueAtracciones: 'evento',
    articulo: 'artigo',
    fecha: 'data',
    ticket: 'bilhete',
    tickets: 'bilhetes',
    confirmDisable: 'confirmar desativar?',
    imageProperties: 'Imagem no formato Jpg, pelo menos 600 x 600 px',
    loginAgain: 'faça login novamente',
    timeExpirationDay: 'Dias válidos para o bilhete. defina "0" para o resto do dia atual',
    trenParada: 'parada de trem',

    error: {
      unableConnect: 'impossível conectar',
      tryAgainLater: 'tente novamente mais tarde',
      loginAgain: 'faça login novamente',
      userNoAccess: 'acesso proibido para esse tipo de usuário'
    }
  },
  it: {
    typePassenger: {
      adult: 'adulti',
      child: 'bambino',
      handicapped: 'disabile',
      infant: 'baby',
      military: 'militare',
      senior: 'maggiore',
      student: 'estudente'
    },

    add: 'Aggiungi',
    address: 'Senso',
    administrator: 'Manager',
    adult: 'Adulti',
    all: 'tutto',
    appName: 'Tpv web',
    articles: 'articoli',
    atraccion: 'Attrazione',
    autobus: 'Bus',
    avion: 'avion',
    barco: 'barco',
    barcode: 'Codice a barre',
    bicicleta: 'Bicicletta',
    branch: 'Delegazione',
    branches: 'delegazioni',
    brand: 'Marchio',
    buceo: 'immersioni subacquee',
    bus: 'Bus',
    businessName: 'Nome fiscale',
    businessunit: 'Business',
    businessUnit: 'Business',
    businessunits: 'Business',
    businessUnits: 'Business',
    busParada: 'Fermata dell autobus',
    busTuristico: 'Autobus turistico',
    calculadora_precios_sin_iva: 'Calcolatore di prezzi senza IVA',
    cancel: 'Annulla',
    canceled: 'Annullato',
    cardAmount: 'Carta',
    cashAmount: 'Cash',
    cashDesk: 'cassa',
    cashDeskOpen: 'La cassa è già aperta',
    checkins: 'Checkins',
    city: 'Città',
    client: 'Client',
    close: 'Chiudi',
    code: 'Codice',
    codeDiscount: 'Codice sconto',
    confirmDelete: 'Conferma l eliminazione?',
    confirmEnable: 'Conferma abilitazione?',
    contactName: 'Persona di contatto',
    contactPhone: 'Telefono di contatto',
    cost: 'Costo',
    customers: 'clienti',
    dateBook: 'Data prenotazione',
    datecheck: 'Rilasciato',
    dateClose: 'Data di chiusura',
    dateOpen: 'Data di apertura',
    daterefund: 'Annullato',
    datevalited: 'Convalidato',
    day: 'Oggi',
    delete: 'Elimina',
    description: 'Descrizione',
    desde: 'Da',
    destination: 'Destino',
    devices: 'Dispositivi',
    disable: 'Disabilita',
    disabled_at: 'Disabilitato in',
    disabled: 'Disabili',
    discount: 'Sconto',
    email: 'E-mail',
    enable: 'Abilita',
    excursion: 'Escursione',
    families: 'famiglie',
    family: 'Famiglia',
    footer: 'Pie',
    from: 'Da',
    funcion: 'Funzione',
    funicular: 'Funicolare',
    hasta: 'A',
    header: 'Intestazione',
    helicopero: 'Elicottero',
    help: 'Aiuto',
    hoponHopoff: 'Hopon-hopoff',
    hopOnOff: 'HopOnOff',
    hora: 'Ora',
    id: 'ID',
    idavuelta: 'Andata e ritorno',
    image: 'Immagine',
    infant: 'Baby',
    invoice: 'fattura',
    lancha: 'arca ',
    lastname: 'Cognome',
    license: 'Licenza',
    licenses: 'Licenze',
    logIn: 'accesso',
    logOut: 'Esci',
    manufacturer: 'Produttore',
    margin: 'Margine',
    military: 'Militare',
    model: 'Modello',
    modelo: 'Modello',
    month: 'Mese',
    moto: 'oto ',
    motoAgua: 'MotoAgua',
    museo: 'Museo',
    name: 'ome ',
    netAmount: 'Base imponibile',
    none: 'No',
    nothingModified: 'Non sono state apportate modifiche',
    number: 'Numero',
    numero: 'numero del biglietto ',
    ok: 'Accetta',
    open: 'apertura',
    operationline: 'Linea di operazione',
    operationlines: 'Linee di operazione',
    origin: 'Origine',
    orphan: 'Senza famiglia',
    panoramica: 'Immagine',
    parael: 'Per il',
    parent: 'Padre',
    partialClose: 'Chiusura parziale',
    passengercategories: 'Categorie di passeggeri',
    password: 'Password',
    patin: 'Skate',
    percentage: 'porcentuale',
    phone: 'telefono',
    policy: 'Politica',
    price: 'Prezzo',
    pricesWithoutTax: 'Prezzi (senza IVA)',
    printPrice: 'stampare prezzo',
    propierties: 'Proprietà',
    province: 'Provincia',
    quantity: 'Importo',
    receiptLayout: 'Modello di ricevuta',
    recovery: 'Ho dimenticato la password',
    reference: 'Riferimento',
    refunded: 'Rimborsato',
    reports: 'segnalazioni',
    reset: 'Restart',
    role: 'Ruolo',
    routes: 'Percorsi',
    ruta: 'Rotta',
    saleDate: 'Da',
    sales: 'vendite',
    save: 'Salva',
    search: 'Cerca',
    seller: 'Venditore',
    send: 'Invia',
    senior: 'Maggiore',
    serial: 'Numero di serie',
    settings: 'configurazione',
    sinValidar: 'non convalidato',
    state: 'Stato',
    stock: 'stock',
    stockable: 'memorizzabili',
    stretch: 'Service',
    stretches: 'Servizi',
    student: 'Student',
    supervisor: 'Supervisore',
    tax: 'imposta',
    taxAmount: 'tassazione',
    taxBase: 'Base imponibile',
    taxes: 'Tasse',
    terminal: 'Terminale di vendita',
    terminalnumero: 'Numero',
    ticketsRefunded: 'Biglietti annullati',
    timeAdvance: 'Tempo prima dell uso per convalidare il biglietto (in minuti)',
    timeCancel: 'Tempo massimo per l´annullamento del biglietto (in minuti)',
    timeExpirationHour: 'Minuti di validità del biglietto dal momento dell´uso',
    tin: 'IF-CIF ',
    to: 'A',
    total: 'Totale',
    totalDiscount: 'Sconto totale',
    totalRefund: 'Totale annullato',
    tradename: 'Nome commerciale',
    tramoHora: 'Valido per un programma',
    tramoHorario: 'Time',
    tranvia: 'tram',
    trenecito: 'Trenino',
    type: 'Tipo',
    typePassengers: 'Tipo di passeggero',
    user: 'Utente',
    username: 'nome utente',
    users: 'Utenti',
    validoPara: 'Valido per',
    vuelta: 'andata e ritorno',
    week: 'Settimana',
    wharehouse: 'Il mio catalogo',
    year: 'Anno',
    zip: 'Codice postale',
    parqueAtracciones: 'Evento',
    articulo: 'articolo',
    fecha: 'Data',
    ticket: 'biglietto',
    tickets: 'iglietti',
    confirmDisable: 'Conferma disabilitazione?',
    imageProperties: 'Immagine in formato jpg con un minimo di 600x600 px',
    loginAgain: 'Accedi di nuovo',
    timeExpirationDay: 'iorni validi per il biglietto. inserisci "0" per il resto del giorno corrente',
    trenParada: 'fermata del treno',

    error: {
      unableConnect: 'Impossibile connettersi',
      tryAgainLater: 'Riprova più tardi',
      loginAgain: 'Accedi di nuovo',
      userNoAccess: 'Accesso vietato per questo tipo di utente'
    }
  },

  fr: {
    typePassenger: {
      adult: 'adulte',
      child: 'enfant',
      handicapped: 'handicapé',
      infant: 'bébé',
      military: 'militaire',
      senior: 'major',
      student: 'Étudiant'
    },

    add: 'Ajouter',
    address: 'adresse',
    administrator: 'Administrateur',
    adult: 'Adulte',
    all: 'tous',
    appName: 'Tpv Web',
    articles: 'Articles',
    atraccion: 'Attraction',
    autobus: 'Bus',
    avion: 'vion',
    barco: 'avire',
    barcode: 'ode barre',
    bicicleta: 'élo',
    branch: 'Délégation',
    branches: 'Délégations',
    brand: 'Marque',
    buceo: 'longée',
    bus: 'Bus',
    businessName: 'Nom fiscal',
    businessunit: 'Business',
    businessUnit: 'Business',
    businessunits: 'Business',
    businessUnits: 'Business',
    busParada: 'Arrêt de bus',
    busTuristico: 'Bus touristique',
    calculadora_precios_sin_iva: 'Calculateur de prix sans TVA',
    cancel: 'Annuler',
    canceled: 'Annulé',
    cardAmount: 'Carte',
    cashAmount: 'Cash',
    cashDesk: 'Box',
    cashDeskOpen: 'La boîte est déjà ouverte',
    checkins: 'Checkins',
    city: 'ille',
    client: 'Client',
    close: 'clôture',
    code: 'Code',
    codeDiscount: 'Code de réduction',
    confirmDelete: 'Confirmer la suppression?',
    confirmEnable: 'Confirmer l´activation?',
    contactName: 'ersonne de contact',
    contactPhone: 'éléphone de contact',
    cost: 'Coût',
    customers: 'Clients',
    dateBook: 'Date de réservation',
    datecheck: 'Émis',
    dateClose: 'Date de clôture',
    dateOpen: 'Date d´ouverture',
    daterefund: 'Annulé',
    datevalited: 'Validé',
    day: 'aujourd´hui',
    delete: 'Supprimer',
    description: 'Description',
    desde: 'e',
    destination: 'estiny',
    devices: 'Dispositifs',
    disable: 'Désactiver',
    disabled_at: 'Disabled in',
    disabled: 'Désactivé',
    discount: 'Remise',
    email: 'mail',
    enable: 'Activer',
    excursion: 'Excursion',
    families: 'Familles',
    family: 'Famille',
    footer: 'ied',
    from: 'e',
    funcion: 'onction',
    funicular: 'uniculaire',
    hasta: 'Jusqu`à´',
    header: 'En-tête',
    helicopero: 'Hélicoptère',
    help: 'ide',
    hoponHopoff: 'HopON-HopOFF',
    hopOnOff: 'HopOnOff',
    hora: 'Heure',
    id: 'ID',
    idavuelta: 'ller-retour',
    image: 'mage',
    infant: 'Bébé',
    invoice: 'Facture',
    lancha: 'ateau',
    lastname: 'Noms',
    license: 'Licence',
    licenses: 'Licences',
    logIn: 'ommencer la session',
    logOut: 'ortir',
    manufacturer: 'Fabricant',
    margin: 'Marge',
    military: 'Militaire',
    model: 'Modèle',
    modelo: 'Modèle',
    month: 'Mois',
    moto: 'oto',
    motoAgua: 'moto aquatique',
    museo: 'Musée',
    name: 'om',
    netAmount: 'Assiette fiscale',
    none: 'Aucun',
    nothingModified: 'Aucun changement n´a été fait',
    number: 'le numéro',
    numero: 'numéro du billet',
    ok: 'Accepter',
    open: 'Ouverture',
    operationline: 'Ligne d´opération',
    operationlines: 'Lignes d´opération',
    origin: 'rigine',
    orphan: 'ans famille',
    panoramica: 'Panoramique',
    parael: 'pour lui',
    parent: 'Père',
    partialClose: 'Fermeture partielle',
    passengercategories: 'Catégories de passagers',
    password: 'Mot de passe',
    patin: 'kate',
    percentage: 'ourcentage',
    phone: 'Téléphone',
    policy: 'Politique',
    price: 'Prix',
    pricesWithoutTax: 'Prix (hors TVA)',
    printPrice: 'Prix d´impression',
    propierties: 'ropriétés',
    province: 'Province',
    quantity: 'Montant',
    receiptLayout: 'odèle de reçu',
    recovery: 'J´ai oublié le mot de passe',
    reference: 'Référence',
    refunded: 'Remboursé',
    reports: 'Rapports',
    reset: 'edémarrer',
    role: 'Rôle',
    routes: 'outes',
    ruta: 'oute',
    saleDate: 'Depuis',
    sales: 'Ventes',
    save: 'auvegarder',
    search: 'hercher',
    seller: 'Vendeur',
    send: 'Envoyer',
    senior: 'Major',
    serial: 'uméro de série',
    settings: 'onfiguration',
    sinValidar: 'Sans validation',
    state: 'État',
    stock: 'Stock',
    stockable: 'Storable',
    stretch: 'Service',
    stretches: 'Services',
    student: 'Étudiant',
    supervisor: 'Superviseur',
    tax: 'Taxe',
    taxAmount: 'Taxes',
    taxBase: 'Assiette fiscale',
    taxes: 'Taxes',
    terminal: 'Terminal de vente',
    terminalnumero: 'e numéro',
    ticketsRefunded: 'Billets annulés',
    timeAdvance: 'Temps nécessaire pour valider le ticket (en minutes) avant utilisation',
    timeCancel: 'Durée maximale d´annulation du ticket (en minutes)',
    timeExpirationHour: 'Minutes de validité du billet à compter de la date d´utilisation',
    tin: 'NIF-CIF',
    to: 'Jusqu`à´',
    total: 'Total',
    totalDiscount: 'Remise totale',
    totalRefund: 'Total annulé',
    tradename: 'om commercial',
    tramoHora: 'Valable pour un horaire',
    tramoHorario: 'Calendrier',
    tranvia: 'tram',
    trenecito: 'etit train',
    type: 'ype',
    typePassengers: 'Type de passager',
    user: 'Utilisateur',
    username: 'Utilisateur',
    users: 'Utilisateurs',
    validoPara: 'Valable pour',
    vuelta: 'aller-retour',
    week: 'Semaine',
    wharehouse: 'on catalogue',
    year: 'Année',
    zip: 'ode postal',
    parqueAtracciones: 'Événement',
    articulo: 'article',
    fecha: 'Date',
    ticket: 'billet',
    tickets: 'billets',
    confirmDisable: 'Confirmer la désactivation?',
    imageProperties: 'Image au format jpg avec un minimum de 600x600 px',
    timeExpirationDay: 'Jours valables pour le billet. mettre "0" pour le reste de la journée ',
    trenParada: 'Arrêt de train',

    error: {
      unableConnect: 'Impossible de se connecter',
      tryAgainLater: 'Réessayez plus tard',
      loginAgain: 'Se reconnecter',
      userNoAccess: 'Accès interdit pour ce type d’utilisateur'
    }
  }
}

const translate = Translate(languages[lang] || defaultLanguage, {
  debug: process.env.NODE_ENV === 'development',
  namespaceSplitter: ':'
})

export const capitalize = (text: string): string => text
  .charAt(0)
  .toUpperCase() + text.slice(1)

export const capitalizeAll = (text: string): string => text.toUpperCase()

export const t = (key: string, replacements?: object) => translate(key, replacements)

export const T = (key: string, replacements?: object): string => capitalize(t(key, replacements))

export const TT = (key: string, replacements?: object): string => capitalizeAll(t(key, replacements))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/i18n.ts